let lastReportedKey: string | null = null;
let lastReportedAt = 0;

/**
 * Fire-and-forget report to the backend when convertDate receives an invalid value.
 * Throttled: the same (value+format) pair is reported at most once every 30 seconds
 * to avoid flooding the log.
 */
export function reportInvalidDate(
  value: unknown,
  format: string | undefined
): void {
  if (typeof window === "undefined") return; // SSR: skip

  const valueStr = (() => {
    try {
      if (value instanceof Date) return `Date(${value.toString()})`;
      if (value === null) return "null";
      if (value === undefined) return "undefined";
      return `${typeof value}: ${String(value)}`;
    } catch {
      return "<unserializable>";
    }
  })();

  const key = `${valueStr}::${format ?? "default"}`;
  const now = Date.now();
  if (lastReportedKey === key && now - lastReportedAt < 30_000) return;
  lastReportedKey = key;
  lastReportedAt = now;

  const payload = {
    timestamp: new Date().toISOString(),
    flow: "other",
    source: "booking-flow",
    errorName: "InvalidDate",
    errorMessage: `convertDate received invalid value (format=${format ?? "default"}): ${valueStr}`,
    platform:
      typeof navigator !== "undefined" ? navigator.platform : "unknown",
    userAgent:
      typeof navigator !== "undefined" ? navigator.userAgent : "unknown",
    url: typeof window !== "undefined" ? window.location.href : undefined,
  };

  try {
    void fetch("/api/log/client-error", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => undefined);
    // eslint-disable-next-line no-console
    console.warn("[InvalidDate]", payload.errorMessage);
  } catch {
    /* ignore */
  }
}
